import { z } from "zod"

export const ModelAddressSchema = z.object({
    fullAddress: z.string(),
    addrCityLabel: z.string(),
    addrNumStreet: z.string(),
    addrPostCode: z.string(),
})
